export default __webpack_public_path__ + "static/media/premium-data.3ea51814.png";